import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_PATCH } from '../../../constants/api';
import { setOrderedParts } from '../../../actions/coilovers/orderedParts/patchOrderedParts';

const patchOrderedParts = createAsyncThunk('orderedParts/patchOrderedParts',
  async ({ _id, formData }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await authSet(METHOD_PATCH, `/co/ordered_parts/${_id}`, formData);
      dispatch(setOrderedParts(data));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchOrderedParts;
